// removed by extract-text-webpack-plugin
module.exports = {"demo":"A_L4N","preview":"_1yGxG","code":"_2UbTH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Demo/Demo.css
// module id = 541
// module chunks = 0